
const routerMarket = {
    path: "market",
    name: "miniapp-market",
    component: () => import("../pages/miniapp/market/Index"),
    props: true,
    children: [
        {
            path: "fund",
            name: "miniapp-market-fund",
            component: () => import("../pages/miniapp/market/fund/Index"),
            props: true
        },
        {
            path: "stock",
            name: "miniapp-market-stock",
            component: () => import("../pages/miniapp/market/stock/Index"),
            props: true
        },
        {
            path: "indices",
            name: "miniapp-market-indices",
            component: () => import("../pages/miniapp/market/indices/Index"),
            props: true
        },
        {
            path: "lotto",
            name: "miniapp-market-lotto",
            component: () => import("../pages/miniapp/market/lotto/index"),
            props: true
        },
        {
            path: "crypto",
            name: "miniapp-market-crypto",
            component: () => import("../pages/miniapp/market/crypto/Index"),
        },
        {
            path: 'gold',
            name: 'miniapp-market-gold',
            component: () => import("../pages/miniapp/market/gold/Index"),
            props: true,
            children: [
                {
                    path: 'trader',
                    name: 'miniapp-market-gold-trader',
                    component: () => import("../pages/miniapp/market/gold/index/Trader"),
                    props: true,
                },
                {
                    path: 'spot',
                    name: 'miniapp-market-gold-spot',
                    component: () => import("../pages/miniapp/market/gold/index/Spot"),
                    props: true,
                }
            ]
        },
    ]
};

export default routerMarket;
